import { breakpoints } from "../global/breakpoints";

const initViewerInPage = () => {
  const slideContainers = document.querySelectorAll('[data-viewer]');

  slideContainers.forEach(slideContainer => {
    const imagesCount = slideContainer.querySelectorAll('img').length;
    $(slideContainer).slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      transitionDuration: 1000,
      autoplay: false,
      infinite: true,
      fade: true,
      arrows: imagesCount > 6,
      prevArrow: '<span class="icon-prev prev"></span>',
      nextArrow: '<span class="icon-next next"></span>',
      responsive: [
        {
          breakpoint: breakpoints.md,
          settings: {
            arrows: imagesCount > 4,
          }
        },
      ],
      asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: slideContainer,
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: breakpoints.md,
          settings: {
            slidesToShow: 4,
          }
        },
      ]
    })
  });
};

initViewerInPage();
